import React from "react";
import {Pagination, PaginationItem, PaginationLink} from "reactstrap";
import {usePagination} from "../../hooks/usePagination";

interface IServerPagination {
    totalPages: number;
    page: number;

    onChange: (page: number) => void;

    className?: string;
}

const ServerPagination: React.FC<IServerPagination> = ({page, totalPages, onChange, className}) => {
    const paginationRange = usePagination({
        totalPages,
        page
    });

    const handleClick = (p: number | string) => {
        if (typeof p === "number" && p !== page) {
            onChange(p);
        }
    };

    const handleArrow = (dir: "prev" | "next") => {
        if (dir === "prev" && page > 1) {
            onChange(page - 1);
        }

        if (dir === "next" && page < totalPages) {
            onChange(page + 1);
        }
    };

    return (
        <Pagination aria-label="Pagination" className={className}>
            <PaginationItem disabled={page === 1}>
                <PaginationLink previous onClick={() => handleArrow("prev")}/>
            </PaginationItem>

            {paginationRange.map((p, idx) => {
                const isEllipsis = p === "DOTS";
                const key = isEllipsis ? `ellipsis-${idx}` : `page-${p}`;

                return (
                    <PaginationItem
                        key={key}
                        active={p === page}
                        disabled={isEllipsis}
                    >
                        <PaginationLink onClick={() => handleClick(p)}>
                            {isEllipsis ? `...` : p}
                        </PaginationLink>
                    </PaginationItem>
                );
            })}

            <PaginationItem disabled={page === totalPages}>
                <PaginationLink next onClick={() => handleArrow("next")}/>
            </PaginationItem>
        </Pagination>
    );
}

export default React.memo(ServerPagination);